import { brl, PLATFORMS } from "@/lib/api";
import { PlatformBadge } from "@/components/Shared";

function PlatformCard({ p }) {
  return (
    <div data-testid={`platform-summary-${p.platform}`} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between"><PlatformBadge platform={p.platform} /><span className="text-xs font-semibold text-slate-500">{p.total_cases} contestaç{p.total_cases === 1 ? "ão" : "ões"}</span></div>
      <p className="mt-4 text-xs font-bold uppercase tracking-wider text-slate-500">Recuperado</p>
      <p className="font-display text-3xl font-extrabold text-slate-900" data-testid={`platform-recovered-${p.platform}`}>{brl(p.recovered_value)}</p>
      <div className="mt-3 flex justify-between text-sm text-slate-600">
        <span>Em disputa: <b data-testid={`platform-contested-${p.platform}`}>{brl(p.contested_value)}</b></span>
        <span>Sucesso: <b data-testid={`platform-rate-${p.platform}`}>{p.approval_rate}%</b></span>
      </div>
    </div>
  );
}

export default function PlatformSummary({ items, platform }) {
  const shown = (items || []).filter((p) => !platform || p.platform === platform);
  if (!shown.length) return null;
  return (
    <div data-testid="platform-summary">
      <p className="mb-3 text-xs font-bold uppercase tracking-wider text-slate-500">Resumo por plataforma{platform ? ` · ${PLATFORMS[platform]}` : ""}</p>
      <div className="grid gap-4 md:grid-cols-3">{shown.map((p) => <PlatformCard key={p.platform} p={p} />)}</div>
    </div>
  );
}
